// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___DV7FZ","root__icon":"style-module__root__icon___ip7c4","root__badge":"style-module__root__badge___Tqu4t","root__copy":"style-module__root__copy___cOeP2","root__name":"style-module__root__name___KfjEY","root__followers":"style-module__root__followers___L30uL"};
    if(module.hot) {
      // 1744730406567
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  